import { Component, Input, OnChanges } from '@angular/core';
import { TimerConfiguration } from '@pdqdev/pdq-shared/dist/interfaces';
import {
  APPEARANCE_TYPES,
  TIMER_STATES,
  TIME_FORMATS,
  isMessageEmpty,
} from '@pdqdev/pdq-shared/dist/utils/extensions-timer-utils';
import {
  getExampleCountdown,
  getTimerBarAlignment,
  getTimerBarBannerIcon,
  getTimerMessageText,
  getTimerPreviewMode,
  getTimerStyleClass,
} from '@utils/timer-utils';

export type TimerPreviewVariant = 'bar' | 'badge';

/**
 * Renders the example countdown timer of an extension preview as an inline bar or a badge
 */
@Component({
  selector: 'timer-preview',
  templateUrl: './timer-preview.component.html',
  styleUrl: './timer-preview.component.scss',
  standalone: false,
})
export class TimerPreviewComponent implements OnChanges {
  @Input({ required: true }) timerConfiguration: TimerConfiguration;
  @Input() variant: TimerPreviewVariant = 'bar';

  visible = false;
  text = '';
  styleClass = '';
  alignmentClass = '';
  icon = '';

  ngOnChanges(): void {
    const previewMode = getTimerPreviewMode(this.timerConfiguration, TIMER_STATES.DEFAULT);
    const message = this.getMessageForMode(previewMode);

    this.visible = Boolean(this.timerConfiguration?.enableCountdownTimer) && !isMessageEmpty(message);
    if (!this.visible) {
      return;
    }

    const countdown = getExampleCountdown(this.timerConfiguration, TIME_FORMATS.DIGITAL);
    this.text = getTimerMessageText(this.timerConfiguration, previewMode, countdown, TIMER_STATES);
    this.styleClass = getTimerStyleClass(
      this.timerConfiguration,
      previewMode,
      `timer-${this.variant}`,
      TIMER_STATES,
      APPEARANCE_TYPES,
    );
    this.alignmentClass = `timer-bar-align-${getTimerBarAlignment(message)}`;
    this.icon = getTimerBarBannerIcon(this.timerConfiguration, previewMode, TIMER_STATES, APPEARANCE_TYPES);
  }

  private getMessageForMode(previewMode: string): string {
    if (previewMode === TIMER_STATES.EXPIRED) {
      return this.timerConfiguration?.expiredMessage;
    }
    if (previewMode === TIMER_STATES.LOW) {
      return this.timerConfiguration?.lowTimerMessage;
    }
    return this.timerConfiguration?.defaultMessage;
  }
}
